import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { mobileDeviceFromUserAgent } from '@hivebrite/utils';
import { Box } from '@design-system/box';
import { ButtonClose } from '@design-system/button';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { __ } from '@design-system/i18n';
import { DefaultLinkSimple } from '@design-system/link';
import { AttachedIcon } from './components/AttachedIcon';
const InnerAttachedFile = ({ customAriaLabelRemove, disabled = false, error, file, loading = false, onRemove, size = 'normal', withLink, }) => {
    const a11yText = customAriaLabelRemove || __('Remove');
    const isSmall = size === 'small';
    const canButtonBeDisplayed = onRemove && !loading && !disabled;
    return (_jsxs(Wrapper, { "$error": Boolean(error), "data-testid": "attachment-file", px: 3, py: isSmall ? 2 : 3, children: [_jsx(Box, { color: "primary", width: isSmall ? 20 : 28, children: _jsx(AttachedIcon, { error: error, loading: loading, size: size, type: file.type }) }), _jsx(FileNameWrapper, { font: isSmall ? 'body-semibold-asphalt' : 'h4-semibold', children: _jsx(FileName, { children: file.name }) }), canButtonBeDisplayed && (_jsx(ButtonClose, { "aria-label": a11yText, onClick: onRemove, screenReadersText: undefined, variant: "secondary" })), withLink && (_jsx(FontAwesomeIcon, { height: isSmall ? '20px' : '24px', iconName: "arrow-down-to-line", iconType: CATEGORIES.REGULAR }))] }));
};
export const AttachedFile = (_a) => {
    var { file, withLink = false } = _a, otherProps = __rest(_a, ["file", "withLink"]);
    return withLink ? (_jsx(AttachedFileLink, { href: file.url, target: mobileDeviceFromUserAgent.Android() ? '_self' : '_blank', children: _jsx(InnerAttachedFile, Object.assign({ file: file, withLink: true }, otherProps)) })) : (_jsx(InnerAttachedFile, Object.assign({ file: file }, otherProps)));
};
const Wrapper = styled(Box).attrs(() => ({
    alignItems: 'center',
    bg: 'smoke',
    flex: 1,
})) `
  outline: ${({ $error, theme }) => $error ? `1px solid ${theme.colors.input.error.color}` : 'none'};
  border-radius: ${({ theme }) => theme.themeVariables.globalBorderRadius}px;
`;
const FileName = styled.span `
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const FileNameWrapper = styled(Box).attrs(() => ({
    flex: 1,
    flexDirection: 'column',
    justifyItems: 'center',
    mx: 3,
})) `
  overflow: hidden;
  white-space: nowrap;
`;
const AttachedFileLink = styled(DefaultLinkSimple) `
  display: block;

  &:hover {
    > :first-child {
      background-color: ${(props) => props.theme.colors.smokeDark};
    }
  }
`;
//# sourceMappingURL=AttachedFile.js.map